module.exports = __webpack_public_path__ + "static/img/annualPackage.66a4428d.png";